export function animateCountUp(
  from: number,
  to: number,
  durationMs: number,
  onUpdate: (value: number) => void,
  onComplete?: () => void
): () => void {
  const safeFrom = Number.isFinite(from) ? from : 0;
  const safeTo = Number.isFinite(to) ? to : 0;
  const safeDuration = Number.isFinite(durationMs) && durationMs > 0 ? durationMs : 1;

  if (safeFrom === safeTo) {
    onUpdate(safeTo);
    onComplete?.();
    return () => undefined;
  }

  const start = performance.now();
  let frameId = 0;

  const step = (timestamp: number) => {
    const progress = Math.min((timestamp - start) / safeDuration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    const value = safeFrom + (safeTo - safeFrom) * eased;
    onUpdate(progress >= 1 ? safeTo : value);

    if (progress < 1) {
      frameId = requestAnimationFrame(step);
    } else {
      onComplete?.();
    }
  };

  frameId = requestAnimationFrame(step);

  return () => cancelAnimationFrame(frameId);
}
